import DocumentsLoadPanel from './DocumentsLoadPanel';

export default DocumentsLoadPanel;
